import React from "react";
import styled, { keyframes } from "styled-components";
import { tokens } from "../../theme/tokens";

// Branded loading spinner (pure CSS — no MUI colour-prop warnings).
//
//   <Spinner size={24} />
//   <Spinner center label="Loading riders…" />

const { colors, spacing, typography } = tokens;

const spin = keyframes`to { transform: rotate(360deg); }`;

const Ring = styled.span`
    display: inline-block;
    width: ${(p) => p.$size}px;
    height: ${(p) => p.$size}px;
    border-radius: 50%;
    border: ${(p) => Math.max(2, Math.round(p.$size / 10))}px solid ${colors.rose};
    border-top-color: ${colors.primary};
    animation: ${spin} 0.7s linear infinite;
`;

const Center = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${spacing[3]};
    padding: ${spacing[7]} ${spacing[4]};
    color: ${colors.muted};
    font-size: ${typography.size.sm};
`;

export default function Spinner({ size = 22, center = false, label, style, ...rest }) {
    if (center) {
        return (
            <Center style={style}>
                <Ring $size={size} {...rest} />
                {label && <span>{label}</span>}
            </Center>
        );
    }
    return <Ring $size={size} style={style} {...rest} />;
}
